import { render, staticRenderFns } from "./submitOrderWaiting.vue?vue&type=template&id=6e2660d5&scoped=true&"
import script from "./submitOrderWaiting.vue?vue&type=script&lang=js&"
export * from "./submitOrderWaiting.vue?vue&type=script&lang=js&"
import style0 from "./submitOrderWaiting.vue?vue&type=style&index=0&id=6e2660d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2660d5",
  null
  
)

export default component.exports